var map = {
	"./default.png": "45d6",
	"./不丹.png": "43f3",
	"./东京.png": "e482",
	"./东帝汶.png": "4007",
	"./中国.png": "a575",
	"./中国台湾地区.png": "c6d5",
	"./中国香港.png": "d5c8",
	"./中国香港特区.png": "e666",
	"./中非.png": "9bbb",
	"./中非共和国.png": "43fb",
	"./中非国旗.png": "5a3a",
	"./丹麦.png": "8f3f",
	"./乌克兰.png": "9fee",
	"./乌兹别克斯坦.png": "cab7",
	"./乌干达.png": "6df8",
	"./乌拉圭.png": "7485",
	"./乍得.png": "9662",
	"./也门.png": "4a24",
	"./亚美尼亚.png": "fbb3",
	"./以色列.png": "a92e",
	"./伊拉克.png": "0b3c",
	"./伊朗.png": "ddbc",
	"./伯利兹.png": "920a",
	"./佛得角.png": "c8bf",
	"./佛得角共和国.png": "f8c1",
	"./俄罗斯.png": "712d",
	"./保加利亚.png": "6f20",
	"./克罗地亚.png": "77c5",
	"./冈比亚.png": "a862",
	"./冰岛.png": "7e3d",
	"./几内亚.png": "f687",
	"./几内亚比绍.png": "6c0f",
	"./列支敦士登.png": "09e5",
	"./刚果共和国.png": "60a1",
	"./刚果布.png": "61bb",
	"./刚果民主共和国.png": "71df",
	"./刚果（布）.png": "5ae9",
	"./刚果（金）.png": "1fd9",
	"./利比亚.png": "52cc",
	"./利比里亚.png": "f00c",
	"./加拿大.png": "6023",
	"./加纳.png": "1d7a",
	"./加蓬.png": "59ff",
	"./匈牙利.png": "7795",
	"./北马其顿.png": "bd30",
	"./南苏丹.png": "4cfa",
	"./南非.png": "a692",
	"./博茨瓦纳.png": "ba3c",
	"./卡塔尔.png": "b804",
	"./卢旺达.png": "3637",
	"./卢森堡.png": "73de",
	"./印度.png": "bfe1",
	"./印度尼西亚.png": "702f",
	"./危地马拉.png": "e214",
	"./厄瓜多尔.png": "0041",
	"./厄立特里亚.png": "d460",
	"./叙利亚.png": "dbfb",
	"./古巴.png": "2ff9",
	"./台湾.png": "8695",
	"./吉尔吉斯斯坦.png": "7e56",
	"./吉布提.png": "6e15",
	"./哈萨克斯坦.png": "1b8b",
	"./哥伦比亚.png": "5ed7",
	"./哥斯达黎加.png": "88e2",
	"./喀麦隆.png": "48a4",
	"./土库曼斯坦.png": "05cb",
	"./土耳其.png": "5953",
	"./圣卢西亚.png": "3be5",
	"./圣基茨和尼维斯.png": "5d3b",
	"./圣多美和普林西比.png": "7725",
	"./圣文森特和格林纳丁斯.png": "d915",
	"./圣马力诺.png": "d251",
	"./圭亚那.png": "84e4",
	"./坦桑尼亚.png": "45e2",
	"./埃及.png": "647b",
	"./埃塞俄比亚.png": "6ccc",
	"./基里巴斯.png": "4a3e",
	"./塔吉克斯坦.png": "0160",
	"./塞内加尔.png": "d8c9",
	"./塞尔维亚.png": "6ef9",
	"./塞拉利昂.png": "2d28",
	"./塞浦路斯.png": "6455",
	"./塞舌尔.png": "1221",
	"./墨西哥.png": "4a7f",
	"./多哥.png": "2566",
	"./多米尼克.png": "1fe4",
	"./多米尼加.png": "1e99",
	"./奥地利.png": "a7d1",
	"./委内瑞拉.png": "ccf0",
	"./孟加拉.png": "c4c1",
	"./孟加拉国.png": "d23d",
	"./安哥拉.png": "d9256",
	"./安提瓜和巴布达.png": "f8cd",
	"./密克罗尼西亚联邦.png": "1bda",
	"./尼加拉瓜.png": "f916",
	"./尼日利亚.png": "ead9",
	"./尼日尔.png": "37e7",
	"./尼泊尔.png": "2e7d",
	"./巴勒斯坦.png": "d6ea",
	"./巴哈马.png": "0ebe",
	"./巴基斯坦.png": "456c",
	"./巴巴多斯.png": "568f",
	"./巴布亚新几内亚.png": "290b",
	"./巴拉圭.png": "7adf",
	"./巴拿马.png": "0671",
	"./巴林.png": "7998",
	"./巴西.png": "c584",
	"./布基纳法索.png": "2949",
	"./布隆迪.png": "2225",
	"./希腊.png": "6b4c",
	"./帕劳.png": "0e2b",
	"./库克群岛.png": "9eee",
	"./德国.png": "6c22",
	"./意大利.png": "78dd",
	"./所罗门群岛.png": "4003",
	"./拉各斯.png": "cc53",
	"./拉脱维亚.png": "5b0e",
	"./挪威.png": "7abe",
	"./捷克.png": "1c10",
	"./摩尔多瓦.png": "39b7",
	"./摩洛哥.png": "82de",
	"./文莱.png": "b76a",
	"./斐济.png": "c5df",
	"./斯威士兰.png": "cf34",
	"./斯威士兰王国.png": "b0fa",
	"./斯洛伐克.png": "cf18",
	"./斯洛伐克共和国.png": "9177",
	"./斯洛文尼亚.png": "e856",
	"./斯里兰卡.png": "6b17",
	"./新加坡.png": "e5e1",
	"./新西兰.png": "a110",
	"./日本.png": "7096",
	"./智利.png": "1b23",
	"./智力.png": "bc8d",
	"./朝鲜.png": "03c8",
	"./柬埔寨.png": "ed3a",
	"./格林纳达.png": "00ac",
	"./格鲁吉亚.png": "91bb",
	"./比利时.png": "fe72",
	"./毛里塔尼亚.png": "2e5e",
	"./毛里求斯.png": "eb90",
	"./汤加.png": "cdb0",
	"./沙特.png": "7c8b",
	"./沙特阿拉伯.png": "8953",
	"./法国.png": "ba59",
	"./波兰.png": "4775",
	"./波多黎各.png": "6e83",
	"./波斯尼亚和黑塞哥维那.png": "4c27",
	"./波黑.png": "d671",
	"./泰国.png": "bb67",
	"./洛杉矶.png": "aa64",
	"./津巴布韦.png": "44b5",
	"./洪都拉斯.png": "1115",
	"./海地.png": "ecf5",
	"./澳大利亚.png": "84de",
	"./爱尔兰.png": "7b25",
	"./爱沙尼亚.png": "4497",
	"./牙买加.png": "a556",
	"./特立尼达和多巴哥.png": "5d82",
	"./玻利维亚.png": "77fc",
	"./瑞典.png": "ab21",
	"./瑞士.png": "e523",
	"./瓦努阿图.png": "f09b",
	"./白俄罗斯.png": "f9f3",
	"./科威特.png": "890f",
	"./科摩罗.png": "7309",
	"./科特迪瓦.png": "6514",
	"./科索沃.png": "4bf0",
	"./秘鲁.png": "2e32",
	"./突尼斯.png": "3a78",
	"./立陶宛.png": "5ecd",
	"./索马里.png": "c160",
	"./约旦.png": "4ba0",
	"./约旦河西岸和加沙.png": "1cf7",
	"./纳米比亚.png": "7a1f",
	"./纽埃.png": "ed1b",
	"./纽约.png": "0768",
	"./缅甸.png": "176a",
	"./罗马尼亚.png": "a4b0",
	"./美国.png": "303a",
	"./老挝.png": "b8bd",
	"./肯尼亚.png": "c5e7",
	"./芬兰.png": "0d23",
	"./苏丹.png": "80c9",
	"./苏里南.png": "dfda",
	"./英国.png": "d5f7",
	"./英国2.png": "268d",
	"./荷兰.png": "691d",
	"./莫桑比克.png": "f90a",
	"./莱索托.png": "cd3a",
	"./菲律宾.png": "6072",
	"./萨尔瓦多.png": "bcb8",
	"./萨摩亚.png": "4a6d",
	"./葡萄牙.png": "1dcf",
	"./蒙古.png": "1f74",
	"./蒙古国.png": "f521",
	"./西班牙.png": "c502",
	"./贝宁.png": "c186",
	"./赞比亚.png": "96c2",
	"./赤道几内亚.png": "768e",
	"./越南.png": "52e3",
	"./阿塞拜疆.png": "51d4",
	"./阿富汗.png": "ac5c",
	"./阿尔及利亚.png": "ce22",
	"./阿尔巴尼亚.png": "81cf",
	"./阿拉伯联合酋长国.png": "d505",
	"./阿曼.png": "5886",
	"./阿根廷.png": "7abc",
	"./阿联酋.png": "fdf2",
	"./雅加达.png": "e74b",
	"./韩国.png": "9be8",
	"./马其顿.png": "2657",
	"./马尔代夫.png": "2f42",
	"./马拉维.png": "8c96",
	"./马来西亚.png": "56cc",
	"./马绍尔群岛.png": "4430",
	"./马耳他.png": "4ce6",
	"./马达加斯加.png": "a192",
	"./马里.png": "7a30",
	"./黎巴嫩.png": "a690",
	"./黑山.png": "3571"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "278f";